<template>
  <table id="GridViewRacing" class="accountTable" cellspacing="0" cellpadding="0" style="border-collapse:collapse;">
    <tr class="tableHead">
      <th scope="col" style="width:15%;">
          <div title="No."> {{ $t('no.') }}</div>
      </th>
      <th align="left" scope="col" style="width:17%;">
          <div title="Ngày">Ngày</div>
      </th>
      <th scope="col" style="width:22%;">
          <div title="Kết&nbsp;quả">Kết&nbsp;quả</div>
      </th>
      <th scope="col" style="width:10%;">
          <div title="Tổng">Tổng</div>
      </th>
      <th scope="col" style="width:10%;">
          <div title="T/X">T/X</div>
      </th>
      <!-- <th scope="col" style="width:10%;">
          <div title="L/C">L/C</div>
      </th> -->
    </tr>
    <tr
      v-for="(column, index) in content"
      :key="index"
      class="tableRow"
      valign="middle"
    >
      <td align="center" style="width:15%;">
        {{ column.id }}
      </td>
      <td style="width:17%;">
        {{ column.endAt }}
      </td>
      <td align="center" style="width:22%;">
        <component :is="classDice(column, 0)"></component>
        <component :is="classDice(column, 1)"></component>
        <component :is="classDice(column, 2)"></component>
      </td>
      <td class="hasTableGroup points-flexible" style="width:10%;">
        <div>
          <span :class="getTotal(column)">{{getTotal(column)}}</span>
        </div>
      </td>
      <td class="hasTableGroup points-flexible" style="width:10%;">
        <div>
          <span :class="getBigSmallColor(column)">{{getBigSmall(column)}}</span>
        </div>
      </td>
      <!-- <td class="hasTableGroup points-flexible" style="width:10%;">
        <div>
          <span :class="getOddColor(column)">{{getOdd(column)}}</span>
        </div>
      </td> -->
    </tr>
    <tr>
      <td colspan="8">
        <div class="pagination">
          <a @click="$emit('first-Page')">«</a>
          <a @click="$emit('previous-Page')">‹</a>
          <input type="text" :value="page" readonly="readonly" />
          <a @click="$emit('next-Page')">›</a>
          <a @click="$emit('last-Page')">»</a>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
import DiceOne from '@assets/icons/dice1.svg';
import DiceTwo from '@assets/icons/dice2.svg';
import DiceThree from '@assets/icons/dice3.svg';
import DiceFour from '@assets/icons/dice4.svg';
import DiceFive from '@assets/icons/dice5.svg';
import DiceSix from '@assets/icons/dice6.svg';

export default {
  components: {
    DiceOne,
    DiceTwo,
    DiceThree,
    DiceFour,
    DiceFive,
    DiceSix,
  },
  props: {
    page: String,
    content: Array,
  },
  methods: {
    getTotal: function(column) {
      // console.log('value', value)
      if(column.resultRaw === null || column.resultRaw === undefined){
        return "";
      }
      const arr = column.resultRaw.split(',');
      return Number.parseInt(arr[0]) + Number.parseInt(arr[1]) + Number.parseInt(arr[2]);
    },
    getBigSmall: function(column) {
      // console.log('value', value)
      if(column.betTypeResult === null || column.betTypeResult === undefined){
        return "";
      }
      const value = column.betTypeResult.split(',')[0];
      return value === "SMALL" ? "X" : "T";
    },
    getOdd: function(column) {
      // console.log('value', value)
      if(column.betTypeResult === null || column.betTypeResult === undefined){
        return "";
      }
      const value = column.betTypeResult.split(',')[1];
      return value === "ODD" ? "L" : "C";
    },
    getBigSmallColor: function(column, pos) {
      if(column.betTypeResult === null || column.betTypeResult === undefined){
        return "";
      }
      const value = column.betTypeResult.split(',')[0];
      return value === "BIG" ? "color-red" : "color-blue";
    },
    getOddColor: function(column, pos) {
      if(column.betTypeResult === null || column.betTypeResult === undefined){
        return "";
      }
      const value = column.betTypeResult.split(',')[1];
      return value === "ODD" ? "color-red" : "color-blue";
    },
    classDice: function(column, pos) {
      if(column.resultRaw === null || column.resultRaw === undefined){
        return "";
      }
      const value = column.resultRaw.split(',')[pos];
      switch(value){
        case "1": return DiceOne;
        case "2": return DiceTwo;
        case "3": return DiceThree;
        case "4": return DiceFour;
        case "5": return DiceFive;
        case "6": return DiceSix;
      }
    },
  }
}
</script>

<style>
  svg {
    width: 50px;
    padding: 5px;
  }

</style>
